import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
import urologyBg1 from '../../assets/img/sidhi/23.png';
import urologyBg2 from '../../assets/img/sidhi/24.png';
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const Orthopedic = () => {
     const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    const images = [ urologyBg1,urologyBg2 ];
     const backgroundImage = images[currentImageIndex];
    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Orthopedics</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Orthopedics</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                        <p>Orthopedic Department at Hitkari Hospital</p>
                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                           
                            <div className="terms-content">
                                <div className="terms-text">
                                    <h3>Orthopedic Department at Hitkari Hospital</h3>
                                     <p>Welcome to the Orthopedic Department at Hitkari Hospital, where we are committed to providing exceptional care for all musculoskeletal conditions. Our team of highly skilled orthopedic surgeons and healthcare professionals utilizes the latest advancements in medical technology and techniques to ensure optimal outcomes for our patients. From sports injuries to joint replacements, we offer a full spectrum of orthopedic services tailored to meet the individual needs of each patient. At Hitkari Hospital, we prioritize your mobility and well-being, striving to help you return to an active and fulfilling life.</p>

                                </div>
                                 <div className="terms-text">
                                      <h3>Comprehensive Services Offered</h3>
                                      <br />
                                      <p>The Orthopedic Department at Hitkari Hospital offers a wide range of services including:</p>
                                     <ul>
                                        <li>
                                            <strong>Joint Replacement Surgery</strong>
                                            <ul>
                                                <li><strong>Hip Replacement:</strong> Alleviating pain and restoring mobility with advanced hip replacement procedures.</li>
                                                <li><strong>Knee Replacement:</strong> Customized knee replacement surgeries to enhance function and reduce pain.</li>
                                                <li><strong>Shoulder and Elbow Replacements:</strong> Treating severe joint damage with effective replacement options.</li>
                                            </ul>
                                        </li>
                                        <li>
                                            <strong>Arthroscopic Surgery</strong>
                                            <ul>
                                                <li><strong>Knee Arthroscopy:</strong> Minimally invasive procedures for ligament repairs, meniscal issues, and cartilage damage.</li>
                                                <li><strong>Shoulder Arthroscopy:</strong> Addressing rotator cuff tears, labral injuries, and impingement syndromes.</li>
                                                <li><strong>Ankle and Elbow Arthroscopy:</strong> Treating a variety of joint conditions with precision and less post-operative discomfort.</li>
                                            </ul>
                                        </li>
                                        <li>
                                            <strong>Sports Medicine</strong>
                                            <ul>
                                                <li><strong>ACL Reconstruction:</strong> Restoring stability to the knee with advanced ACL repair techniques.</li>
                                                <li><strong>Meniscus Repair:</strong> Preserving the natural function of the knee through minimally invasive meniscal procedures.</li>
                                                <li><strong>Fracture Management:</strong> Comprehensive treatment for sports-related fractures, sprains, and dislocations.</li>
                                            </ul>
                                        </li>
                                        <li>
                                             <strong>Trauma and Fracture Care</strong>
                                            <ul>
                                                <li><strong>Complex Fracture Management:</strong> Expertise in treating complicated fractures and polytrauma cases.</li>
                                                 <li><strong>Non-union and Malunion Correction:</strong> Surgical solutions for fractures that have failed to heal properly.</li>
                                                <li><strong>Minimally Invasive Fracture Repair:</strong> Employing advanced techniques to minimize scarring and speed up recovery.</li>
                                            </ul>
                                        </li>
                                          <li>
                                            <strong>Spine Surgery</strong>
                                            <ul>
                                                  <li><strong>Microdiscectomy:</strong> Relieving nerve compression and back pain through precise surgical methods.</li>
                                                <li><strong>Spinal Fusion:</strong> Stabilizing the spine with effective fusion techniques for chronic conditions.</li>
                                                <li><strong>Laminectomy:</strong> Decompressing the spinal cord and nerves to alleviate pain and improve mobility.</li>
                                            </ul>
                                        </li>
                                          <li>
                                              <strong>Pediatric Orthopedics</strong>
                                            <ul>
                                                <li><strong>Congenital Deformities:</strong> Managing and treating orthopedic conditions present at birth.</li>
                                                <li><strong>Growth Plate Fractures:</strong> Specializing in the treatment of fractures affecting children's growth plates.</li>
                                                <li><strong>Scoliosis and Spinal Deformities:</strong> Expert care for spinal curvature conditions in children and adolescents.</li>
                                            </ul>
                                        </li>
                                        <li>
                                            <strong>Hand and Upper Extremity Surgery</strong>
                                            <ul>
                                                  <li><strong>Carpal Tunnel Release:</strong> Decompressing the median nerve to relieve symptoms of carpal tunnel syndrome.</li>
                                                <li><strong>Trigger Finger Surgery:</strong> Addressing painful finger conditions through targeted surgical procedures.</li>
                                                <li><strong>Fracture Repair and Joint Reconstruction:</strong> Treating a variety of hand and wrist injuries with precision techniques.</li>
                                            </ul>
                                        </li>
                                           <li>
                                            <strong>Foot and Ankle Surgery</strong>
                                            <ul>
                                                  <li><strong>Bunion Correction:</strong> Minimally invasive surgical options for painful bunions.</li>
                                                <li><strong>Ankle Sprain and Fracture Management:</strong> Specialized treatment for various foot and ankle injuries.</li>
                                                <li><strong>Plantar Fasciitis Treatment:</strong> Comprehensive care for heel pain and foot discomfort.</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Why Choose the Orthopedic Department at Hitkari Hospital?</h3>
                                    <br />
                                      <ul>
                                            <li><strong>Experienced Surgeons:</strong> Highly qualified orthopedic surgeons with extensive experience in various procedures.</li>
                                            <li><strong>Advanced Technology:</strong> State-of-the-art surgical facilities and diagnostic equipment.</li>
                                            <li><strong>Personalized Care:</strong> Tailored treatment plans to meet the specific needs of each patient.</li>
                                             <li><strong>Comprehensive Approach:</strong> From diagnosis to rehabilitation, we provide seamless care.</li>
                                              <li><strong>Patient-Centric Environment:</strong> Focus on making patients comfortable and informed at every step.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Our Commitment to Orthopedic Care</h3>
                                    <br />
                                   <p>At Hitkari Hospital, we are dedicated to improving the lives of our patients through innovative orthopedic care, compassionate service, and a focus on achieving the best possible outcomes. Whether you are seeking relief from pain, aiming to regain mobility, or recovering from an injury, our Orthopedic Department is here to support you every step of the way. Contact us today to schedule a consultation and discover how our expert team can help you on your path to better musculoskeletal health.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default Orthopedic;